import React from 'react';
import { LocationSearch } from '../../../components';

export default function PoisServiceTab() {
  return <LocationSearch key="tab-pois-service" />;
}
